/*
 * @Author: huangzeshen
 * @Date: 2023-07-04 15:55:01
 * @LastEditors: huangzeshen
 * @LastEditTime: 2023-09-28 15:00:35
 * @FilePath: /open-web/src/locals/en-US/stock.js
 * @Description: 
 */
export default {
  // 通用名称
  'stock.common.Pre-market': 'Pre',
  'stock.common.After-market': 'After',
  'stock.common.cur.hk': 'HK$',
  'stock.common.cur.us': '$',
  'stock.common.cur.cn': 'CNY',
  'stock.common.cur.shares': ' shares',
  // 通知
  'stock.notion.btn': 'I SEE',
  // 自选
  'stock.index.header.title': 'Watchlist',
  'stock.index.tabs.1': 'All',
  'stock.index.tabs.2': 'US',
  'stock.index.tabs.3': 'HK',
  'stock.index.tabs.4': 'CN',
  'stock.index.add': 'Add to watchlist',
  'stock.index.table.edit': 'Edit',
  'stock.index.table.price': 'Price',
  'stock.index.table.changePercent': 'Chg%',

  // 编辑自选
  'stock.edit.header.title': 'Edit',
  'stock.edit.header.save': 'Save',
  'stock.edit.header.all': 'All',
  'stock.edit.header.delete': 'Delete',
  'stock.edit.table.header.1': 'Stock code',
  'stock.edit.table.header.2': 'Top',
  'stock.edit.table.header.3': 'Up',
  'stock.edit.table.header.4': 'Down',
  'stock.edit.success': 'edit success',

  // 股票详情
  'stock.details.list.title': 'Market Data',
  'stock.details.list.1': 'Open',
  'stock.details.list.2': 'Close',
  'stock.details.list.3': 'High',
  'stock.details.list.4': 'Low',
  'stock.details.list.5': 'Vol',
  'stock.details.list.6': 'T/O',
  'stock.details.list.7': 'Mkt cap',
  'stock.details.list.8': 'T/O rate',
  'stock.details.list.9': 'Total shares',
  'stock.details.list.10': 'P/E',
  'stock.details.list.11': 'Lot size',
  'stock.details.list.12': 'Cur',
  'stock.details.list.13': 'Chg',
  'stock.details.list.14': 'Avg. price',
  'stock.details.list.15': '52wk high',
  'stock.details.list.16': '52wk low',
  'stock.details.list.17': 'Up',
  'stock.details.list.18': 'Flat',
  'stock.details.list.19': 'Down',
  'stock.details.list.20': 'Total issued',
  'stock.details.list.21': 'NAV',
  'stock.details.list.22': 'AUM',
  'stock.details.list.23': 'P/R',
  'stock.details.list.24': 'Strike price',
  'stock.details.list.25': 'Breakeven',
  'stock.details.list.26': 'Public Trading Vol',
  'stock.details.list.27': 'Public Float',
  'stock.details.list.28': 'Conversion price',
  'stock.details.list.29': 'Conversion Ratio',
  'stock.details.list.30': 'Recovery Price',
  'stock.details.list.31': 'Leverage Ratio',
  'stock.details.list.32': 'Last Trade',
  'stock.details.list.33': 'Expire at',
  'stock.details.list.34': 'Hedge value',
  'stock.details.list.35': 'Premium',
  'stock.details.list.36': 'Asset class',
  'stock.details.list.37': 'Currency',



  // 搜索
  'stock.search.hedaer.tips': 'SEARCH',
  'stock.search.hedaer.History': 'History',
  'stock.search.hedaer.etf': 'Stock&ETFs',

  // 快捷交易
  'stock.trade.header.title': 'Trade',
  'stock.trade.btn.text.1': 'Buy',
  'stock.trade.btn.text.2': 'Sell',
  'stock.trade.btn.text.3': 'LMT order',
  'stock.trade.btn.text.4': 'Price',
  'stock.trade.btn.text.5': 'Quantity',
  'stock.trade.btn.text.6': 'Enter value',
  'stock.trade.btn.text.7': 'Est.Cost',
  'stock.trade.btn.text.8': 'Pre/after-market trading',
  'stock.trade.btn.text.9': 'Yes',
  'stock.trade.btn.text.10': 'No',
  'stock.trade.btn.text.11': 'Available: ',
  'stock.trade.btn.text.12': 'Buy with cash: ',
  'stock.trade.btn.text.13': 'margin: ',
  'stock.trade.btn.text.14': 'Max ',
  'stock.trade.btn.text.15': ' leverage',
  'stock.trade.btn.text.16': 'Market order',
  'stock.trade.btn.text.17': 'Limit order',
  'stock.trade.btn.text.18': 'Enter price',

  'internal_khshz': 'Your account is under approval',
  'open_account_status_2': 'AccountUnopened',
  'auction_buy': 'Call Auct Buy',
  'auction_sell': 'Call Auct Sell',
  'pre_market_buy': 'Pre-Hrs Buy',
  'pre_market_sell': 'Pre-Hrs Sell',
  'after_market_buy': 'Aft-Hrs Buy',
  'after_market_sell': 'Aft-Mkt Sell',
  'buy': 'Buy',
  'sell': 'Sell',
  'add_to_follow_success': 'Added to watchlist',
  'delete_from_follow_success': 'Removed from watchlist',
  'pre_market': 'Pre-Hrs',
  'after_market': 'Aft-Hrs',
  'internal_lz': 'Warrant',
  "not_open": 'Not yet open',
  "pre_market_bidding": 'Pre-market trading',
  "wait_opening": 'Awaiting opening',
  "trading": 'Trading',
  "lunchtime_break": 'Midday recess',
  "closing_bid": 'Closing auction',
  "closed": 'Closed',
  "in_recess": 'Market closed',
  "after_hours_dealing": 'After-hours trading',
  "premarket_trading": 'Pre-market trading',
  "stock_market_sh_csc": 'SH-HK',
  "stock_market_sz_csc": 'SZ-HK',
  "all_position": 'All',
  "half_position": '1/2',
  "one_third_of_position": '1/3',
  "one_fourth_of_position": '1/4',
  "internal_gpdm": 'Stock code',
  "stock": 'Stock',
  "type": 'Type',
  "direction": 'Direction',
  "use_rz_buy": 'Financing included',
  "cancel": 'Cancel',
  "internal_qr": 'Confirm',
  'error_amount_value_1': 'Auto-corrected to be integral multiple of a lot(',
  'error_amount_value_2': 'share(s))',
  'trade_order_confirm': 'Order confirm',
  'success_text': 'Success',
  'currency_type': 'Currency',
  'asset_product': 'Commodity',
  'asset_futures': 'Futures',
  'asset_fixed_rate_product': 'Fixed income product',
  'asset_multi_asset': 'Diversified assets',
  'hold': 'position',
  'trade_freeze': 'Frozen',
  'trade_can_sell': 'Sellable',
  'place_order_success_tip': 'Submitted, pending',

}
